<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" novalidate="" [formGroup]="editForm" (ngSubmit)="save(editForm.value)">
    <modal-header [plugin]="plugin" [menuModal]="menuModal"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <table class="ir-modal-table">
          <tr>
            <td class="margin-big">
              <h2>
                <span
                  ><strong>{{ 'plugins.inspection-info.start-date' | translate }} <i>*</i></strong></span
                >
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group">
                <validation-message
                  [validationControl]="editForm.controls.StartDate"
                  [validationName]="'required'"
                  [errorMessage]="'common.required' | translate"
                ></validation-message>
                <input
                  type="date"
                  name="StartDate"
                  class="ir-form-set"
                  [max]="editForm.controls.EndDate.value | inputDate"
                  formControlName="StartDate"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span>{{ 'plugins.inspection-info.end-date' | translate }}</span>
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group">
                <validation-message
                  [validationControl]="editForm.controls.EndDate"
                  [validationName]="'required'"
                  [errorMessage]="'common.required' | translate"
                ></validation-message>
                <input
                  type="date"
                  name="EndDate"
                  class="ir-form-set"
                  [min]="editForm.controls.StartDate.value | inputDate"
                  formControlName="EndDate"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span>{{ 'plugins.inspection-info.defined-duration' | translate }}</span>
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group">
                <validation-message
                  [validationControl]="editForm.controls.DefinedDuration"
                  [validationName]="'required'"
                  [errorMessage]="'common.required' | translate"
                ></validation-message>
                <input
                  type="number"
                  step="0.5"
                  name="DefinedDuration"
                  class="ir-form-set"
                  formControlName="DefinedDuration"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin">
              <h2>
                <span>{{ 'plugins.inspection-info.notification' | translate }} #</span>
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group">
                <validation-message
                  [validationControl]="editForm.controls.NotificationNumber"
                  [validationName]="'required'"
                  [errorMessage]="'common.required' | translate"
                ></validation-message>
                <input type="text" name="NotificationNumber" class="ir-form-set" formControlName="NotificationNumber" />
              </div>
            </td>
          </tr>
          <ng-container formArrayName="WorkOrders">
            <tr *ngFor="let wo of WorkOrders.controls; let i = index">
              <td class="margin">
                <h2 *ngIf="i === 0">
                  <span><strong>{{ 'plugins.inspection-info.work-order' | translate }} <i>*</i></strong></span>
                </h2>
              </td>
              <td class="margin">
                <div class="ir-form-group">
                  <validation-message
                    [validationControl]="wo"
                    [validationName]="'required'"
                    [errorMessage]="'common.required' | translate"
                  ></validation-message>
                  <validation-message
                    [validationControl]="wo"
                    [validationName]="'pattern'"
                    [errorMessage]="'plugins.inspection-info.work-order-invalid' | translate"
                  ></validation-message>
                  <input type="text" class="ir-form-set" [formControlName]="i" maxlength="8" />
                </div>
              </td>
              <td *ngIf="i === 0 && WorkOrders.length < 5" class="th-plugin-line--numbers">
                <i (click)="addWorkOrder()" class="material-icons">add_circle</i>
              </td>
              <td *ngIf="i > 0" class="th-plugin-line--remove">
                <i (click)="removeWorkOrder(i)" class="material-icons">remove_circle</i>
              </td>
            </tr>
          </ng-container>
          <tr>
            <td class="margin">
              <h2>
                <span>{{ 'plugins.inspection-info.type-inspection' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big">
              <div class="ir-form-group">
                <validation-message
                  [validationControl]="editForm.controls.TypeInspection"
                  [validationName]="'required'"
                  [errorMessage]="'common.required' | translate"
                ></validation-message>
                <input type="hidden" name="TypeInspection" class="ir-form-set" formControlName="TypeInspection" />
                <div class="ir-line ir-select th-select" (click)="openTypeInspectionsSelector()">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-modal--content">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span>{{
                      editForm.controls.TypeInspection.value != -1
                        ? (editForm.controls.TypeInspection.value | inspectiontype)
                        : ('plugins.inspection-info.select-type-inspection' | translate)
                    }}</span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            type="submit"
            [disabled]="editForm.invalid"
            *ngIf="!processing"
          >
            <span>{{ 'common.save-changes' | translate }}</span>
          </button>
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
            type="submit"
            *ngIf="processing"
          >
            <span>{{ 'common.processing' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<confirm
  #deleteConfirm
  (confirmOutput)="deletePlugin($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
<confirm
  #statusUpdateConfirm
  (confirmOutput)="updateStatus()"
  (modalClosed)="cancel()"
  [title]="'inspections.update-status.title' | translate"
  [okButtonText]="'inspections.update-status.update' | translate"
  [message]="'inspections.update-status.scheduled-text' | translate"
  [cancelButtonText]="'inspections.update-status.later' | translate"
  [center]="false"
  [danger]="true"
></confirm>
<modal
  (modalOutput)="selectTypeInspectionsMenu($event)"
  (modalClosed)="onTypeInspectionsMenuClose($event)"
  #TypeInspectionsModal
></modal>
